import axios from "axios";
import { useURL } from "../data/Config";
import { IProfessional } from "../types";

export const fetchProfessionals = async (
  searchQuery?: string
): Promise<IProfessional[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(
    `${useURL}/professionals/all-professionals`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );
  return response.data.professionals;
};
